/* eslint-disable no-unused-vars */
import { functions } from "@/firebaseConfig";

var createUser = functions.httpsCallable("createUser");
var updateUser = functions.httpsCallable("updateUser");
var listUsers = functions.httpsCallable("listUsers");
var sendEmail = functions.httpsCallable("sendEmail");
let validateSession = functions.httpsCallable("validateSession");
let pay = functions.httpsCallable("pay");
let chargeStripe = functions.httpsCallable("chargeStripe");
let createMerchantParameters = functions.httpsCallable(
  "createMerchantParameters"
);
let sendRedsysRequest = functions.httpsCallable("sendRedsysRequest");

export default store => {
  return {
    async createFirebaseUser(data) {
      // eslint-disable-next-line no-useless-catch
      try {
        return await createUser(data);
      } catch (error) {
        throw error;
      }
    },
    async updateFirebaseUser(data) {
      // eslint-disable-next-line no-useless-catch
      try {
        return await updateUser(data);
      } catch (error) {
        throw error;
      }
    },
    async listFirebaseUsers(page) {
      // eslint-disable-next-line no-useless-catch
      try {
        let result = await listUsers();
        return result.data;
      } catch (error) {
        throw error;
      }
    },
    async sendEmail(data) {
      // eslint-disable-next-line no-useless-catch
      try {
        let result = await sendEmail(data);
        return result.data;
      } catch (error) {
        throw error;
      }
    },
    async validateSession(data) {
      // eslint-disable-next-line no-useless-catch
      try {
        let result = await validateSession(data);
        return result.data;
      } catch (error) {
        throw error;
      }
    },
    async pay(data) {
      // eslint-disable-next-line no-useless-catch
      try {
        let result = await pay(data);
        return result.data;
      } catch (error) {
        throw error;
      }
    },
    async chargeStripe(data) {
      // eslint-disable-next-line no-useless-catch
      try {
        let result = await chargeStripe(data);
        return result.data;
      } catch (error) {
        throw error;
      }
    },
    async createMerchantParameters(data) {
      // eslint-disable-next-line no-useless-catch
      try {
        let result = await createMerchantParameters(data);
        return result.data;
      } catch (error) {
        throw error;
      }
    },
    async sendRedsysRequest(data) {
      // eslint-disable-next-line no-useless-catch
      try {
        let result = await sendRedsysRequest(data);
        return result.data;
      } catch (error) {
        throw error;
      }
    }
  };
};
